import { Button } from '@restworld/ui-ds-base';
import { memo } from 'react';
import { AuthTitle } from '../common/auth-title';
import { AuthSubtitle } from '../common/auth-subtitle';
import { ModalWrapper } from '../common/modal-wrapper';
import { Separator } from '../common/separator';
import { GoogleButton } from '../common/google-button';
import { FacebookButton } from '../common/facebook-button';
import { useAtomValue, useSetAtom } from 'jotai';
import {
  ContentType as ModalContentType,
  closeAuthFlowModal,
  closeOtpVerificationAssistanceModal,
  isOtpVerificationAssistanceModalOpen,
  setActiveContent as setActiveModalContent,
} from '../../context/auth-flow';
import { useIntercom } from 'react-use-intercom';
import { useTranslation } from 'next-i18next';

export const AssistanceOTPCodeModal = memo(() => {
  const { show: showIntercom } = useIntercom();
  const open = useAtomValue(isOtpVerificationAssistanceModalOpen);
  const closeAssistanceModal = useSetAtom(closeOtpVerificationAssistanceModal);
  const setActiveContent = useSetAtom(setActiveModalContent);
  const closeModal = useSetAtom(closeAuthFlowModal);
  function onClose() {
    closeAssistanceModal();
    setActiveContent(ModalContentType.NO_CONTENT);
    closeModal();
  }
  const { t } = useTranslation('auth-flow');
  return (
    <ModalWrapper open={open} onClose={onClose}>
      <div className="flex flex-col w-full mt-5 ">
        <form className="w-full">
          <Header />
          <div className="flex flex-col items-center my-10">
            <Button
              fullwidth={true}
              onClick={(e) => {
                e.preventDefault();
                showIntercom();
              }}
            >
              {t('otp_code_assistance_modal_action_text')}
            </Button>
          </div>

          <div className="flex flex-col items-center w-full gap-2">
            <Separator />
            <GoogleButton {...{ isModal: true, closeModal: onClose }} />
            <FacebookButton {...{ isModal: true, closeModal: onClose }} />
          </div>
        </form>
      </div>
    </ModalWrapper>
  );
});

const Header = () => {
  const { t } = useTranslation('auth-flow');
  return (
    <div className="flex flex-col items-center gap-2 w-full">
      <AuthTitle>{t('otp_code_assistance_modal_header')}</AuthTitle>
      <AuthSubtitle>{t('otp_code_assistance_modal_subheader')}</AuthSubtitle>
    </div>
  );
};
